export default "__VITE_ASSET__dgGa4IYh__"